function check_password(e) {
  const confirm = e.target.id === "user_password_confirmation"
  var elem = document.getElementById('user_password');
  if (elem.value.length > 0) {
    if (elem.value.length < 12) {
      document.getElementById('nbr').style.display = 'block';
    } else {
      document.getElementById('nbr').style.display = 'none';
    }
    // label.innerHTML = "You need " + (12 - elem.value.length) + " characters more. ";
    if (!elem.value.match(/(?=.*\d)/)) {
      document.getElementById('digit').style.display = 'block';
    } else {
      document.getElementById('digit').style.display = 'none';
    }
    if (!elem.value.match(/(?=.*[a-z])/)) {
      document.getElementById('lowercase').style.display = 'block';
    } else {
      document.getElementById('lowercase').style.display = 'none';
    }
    if (!elem.value.match(/(?=.*[A-Z])/)) {
      document.getElementById('uppercase').style.display = 'block';
    } else {
      document.getElementById('uppercase').style.display = 'none';
    }
    if (!elem.value.match(/(?=.*\W)/)){
      document.getElementById('special').style.display = 'block';
    } else {
      document.getElementById('special').style.display = 'none';
    }
    if (confirm && elem.value != document.getElementById('user_password_confirmation').value) {
      document.getElementById('confirm').style.display = 'block';
    } else {
      document.getElementById('confirm').style.display = 'none';
    }
  } 
}

function PasswordValidation() {
  var password = document.getElementById('user_password');
  var password_confirm = document.getElementById('user_password_confirmation');
  if (password && password_confirm) {
    password.addEventListener("input", check_password);
    password_confirm.addEventListener("input", check_password);
  }
}

$(document).ready(function() {
  PasswordValidation()
})